import { observer } from 'mobx-react';
import { CheckboxRequirementType } from '.';
import TableHeader from './TableHeader';
import TableBody from './TableBody';

interface Props {
  tableColCount: number;
  checkBoxRequirement: CheckboxRequirementType;
  tableRowCount: number;
}

function Table({ tableRowCount, tableColCount, checkBoxRequirement }: Props) {
  return (
    <div className="animate-pulse">
      <table className="w-full text-gray-400">
        <thead className="dark:bg-gray-50">
          <TableHeader tableColCount={tableColCount} checkBoxRequirement={checkBoxRequirement} />
        </thead>
        <tbody>
          <TableBody
            tableColCount={tableColCount}
            checkBoxRequirement={checkBoxRequirement}
            tableRowCount={tableRowCount}
          />
        </tbody>
      </table>
    </div>
  );
}

export default observer(Table);
